import { Tone } from 'services/agents/types';
import { Tone as ToneGenerated } from 'generated-graphql/types';

export const convertToGeneratedAgentTone = (
  tone: Tone | undefined | null
): ToneGenerated | undefined | null => {
  switch (tone) {
    case Tone.CASUAL:
      return ToneGenerated.Casual;
    case Tone.ENCOURAGING:
      return ToneGenerated.Encouraging;
    case Tone.FRIENDLY:
      return ToneGenerated.Friendly;
    case Tone.MOTIVATIONAL:
      return ToneGenerated.Motivational;
    case Tone.NEUTRAL:
      return ToneGenerated.Neutral;
    case Tone.PROFESSIONAL:
      return ToneGenerated.Professional;
    default:
      return undefined;
  }
};
